import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { InquiryApi } from "@lbsdk/*";

@Injectable({
  providedIn: "root",
})
export class InquiriesService implements Resolve<any> {
  inquiries: any[];
  onInquiriesChanged: BehaviorSubject<any> = new BehaviorSubject({});

  noOfInquiresAtStart: any = 0;
  noOfInquires: any = 0;
  onNoOfInquiresChanged: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(private _inquiryApi: InquiryApi) {}

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getInquiries(), this.getInquiresCount()]).then(() => {
        resolve();
      }, reject);
    });
  }

  getInquiries(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._inquiryApi
        .find({
          limit: 5,
          skip: 0,
          order: "createdAt DESC",
          include: ["player", "playerPrize"],
        })
        .subscribe((response: any) => {
          this.inquiries = response;
          this.onInquiriesChanged.next(this.inquiries);
          resolve(response);
        }, reject);
    });
  }

  getInquiresCount(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._inquiryApi.count().subscribe((res) => {
        this.noOfInquires = res.count;
        this.noOfInquiresAtStart = res.count;
        this.onNoOfInquiresChanged.next(res.count);
        resolve(res.count);
      }, reject);
    });
  }

  updateInquiry(inquiry) {
    return this._inquiryApi.patchAttributes(inquiry.id, {
      readByAdmin: inquiry.readByAdmin,
    });
  }
}
